import { redirect } from "react-router";
import { jwtDecode } from "jwt-decode";

export interface User {
    id: string;
    email: string;
    roles: string[];
    firstName?: string;
    lastName?: string;
    [key: string]: any;
}

export function getUser(): User | null {

    const userStr = localStorage.getItem("user");
    if (!userStr) return null;

    try {
        return JSON.parse(userStr);
    } catch (e) {
        return null;
    }
}

export function getToken(): string | null {
    return localStorage.getItem("token");
}

export function isTokenValid(token: string): boolean {
    try {
        const decoded: any = jwtDecode(token);
        // exp is in seconds, Date.now() is in ms
        const currentTime = Date.now() / 1000;
        return decoded.exp > currentTime;
    } catch (error) {
        return false;
    }
}

export async function requireAuth(request?: Request) {
    const user = getUser();
    const token = getToken();

    if (!user || !token || !isTokenValid(token)) {
        const url = new URL(request?.url || window.location.href);
        const searchParams = new URLSearchParams([
            ["redirectTo", url.pathname + url.search],
        ]);
        throw redirect(`/login?${searchParams}`);
    }

    return user;
}

export async function requireRole(allowedRoles: string[], request?: Request) {
    const user = await requireAuth(request);

    const allowed = allowedRoles.map(r => r.toUpperCase());
    const userRoles = user.roles || [];

    const hasRole = userRoles.some((role: string) => allowed.includes(role));

    if (!hasRole) {
        throw redirect("/forbidden");
    }

    return user;
}

export async function requireAdmin(request?: Request) {
    return requireRole(["ADMIN", "SUPER_ADMIN"], request); // Assuming ADMIN or SUPER_ADMIN
}
